/**
 * 销售数据概览数据管理
 */
import api from '../../api/api'
import * as types from '../mutation'
import { getNowTime } from '../../utils/com'
import { newsType } from '../../config/config'

const state = {
    newsdata: {},
    newstotal: 0,
    newContent: {},
    userlist: [],
    // productSales: {}
}

const getters = {
    newsdata: state => state.newsdata,
    newstotal: state => state.newstotal,
    newContent: state => state.newContent,
    userlist: state => state.userlist,
    // productSales: state => state.productSales
}

const actions = {
    /**
     * 获取销售数据概览数据
     */
    getEditorData({ commit, state, rootState }, param) {
        // loading 开始
        // commit(types.COM_LOADING_STATUS,true)
        // console.debug("getEditorData> param:%o, state:%o, rootState:%o", param, state, rootState);
        api.apiCommunication('/api/news/list', param, function(response) {
            // console.debug("/api/news/list> response:%o", response);
            // console.log(response);
            // 获取成功，提交mutations处理数据
            commit(types.GET_NEWS_LIST_SUCCESS, { response })
            // loading 结束
            // commit(types.COMM_LOADING_STATUS,false)
        })
    },

    getNewsData({ commit, state, rootState }, param) {
        // console.debug("getNewsData> param:%o", param);
        commit(types.GET_NEWS_LIST_SUCCESS, {})
        return new Promise((resolve, reject) => {
            api.apiCommunication(
                '/api/news/list',
                param,
                (response) => {
                    // console.debug("getNewsData ok response:%o", response);
                    commit(types.GET_NEWS_LIST_SUCCESS, { response })
                    if (typeof(resolve) === 'function') {
                        resolve(response)
                    }
                },
                (err) => {
                    console.error("getNewsData err:%o", err);
                    if (typeof(reject) === 'function') {
                        reject(err)
                    }
                })
        });

    },

    updateNewsData({ commit }, param) {
        // console.debug("updateNewsData> param:%o", param);
        let response = {};
        response.code = 0;
        commit(types.UPDATE_NEWS_DATA, { response, param })
    },

    updateNewsDataDone({ commit }, param) {
        // console.debug("updateNewsDataDone> param:%o", param);
        commit(types.ADD_NEWS_DATA_DONE, { param })
    },

    /**
     * 获取订单列表
     */
    addNewsContent({ commit }, param) {
        // console.debug("addNewsContent> param:%o", param);

        return new Promise((resolve, reject) => {
            api.apiCommunication(
                '/api/news/add',
                param,
                (response) => {
                    /*console.debug("addNewsContent ok response:%o", response);*/

                    //去重
                    // if(param.newlabels && param.labels){
                    //     let nla = param.newlabels.length>0 ? param.newlabels.split('#') : [];
                    //     let la = param.labels.length>0 ? param.labels.split('#') : [];
                    //     for(let i in nla){
                    //       la = la.filter(user => {
                    //         if (nla[i] && user === nla[i] ) return false;
                    //         return true;
                    //       });
                    //     }
                    //     param.labels = la.length > 0 ? (nla.join('#') + '#' + la.join('#')) : nla.join('#')
                    //     param.newlabels = nla.length > 0 ? nla.join('#') : ''
                    //     console.debug("addNewsContent> labels:%o, newlabels:%o", param.labels, param.newlabels);
                    // }

                    // contract labels and newlabels to newlabels
                    // param.newlabels = param.newlabels.split('#')
                    // param.labels = param.labels.split('#')
                    // let labels = param.labels.concat(param.newlabels);
                    //remove empty array
                    // labels = labels.filter(t => t!=undefined && t!==null && t !=='');
                    // param.labels = labels.join('#');

                    commit(types.ADD_NEWS_CONTENT, { response, param })
                    if (typeof(resolve) === 'function') {
                        resolve(response)
                    }
                },
                (err) => {
                    /*console.debug("addNewsContent err err:%o", err);*/
                    if (typeof(reject) === 'function') {
                        reject(err)
                    }
                }
            )
        });

    },

    editNewsContent({ commit }, param) {
        // console.debug("editNewsContent> param:%o", param);
        return new Promise((resolve, reject) => {
            api.apiCommunication(
                '/api/news/edit',
                param,
                (response) => {
                    // console.debug("editNewsContent response:%o", response);

                    commit(types.UPDATE_NEWS_CONTENT, { response, param })
                    if (typeof(resolve) === 'function') {
                        resolve(response)
                    }
                },
                (err) => {
                    /*console.debug("editNewsContent err:%o", err);*/
                    if (typeof(reject) === 'function') {
                        reject(err)
                    }
                }
            )
        });

    },


    queryUnusedContent({ commit }, param) {
        // console.debug("queryUnusedContent> param:%o", param);
        return new Promise((resolve, reject) => {
            api.apiCommunication(
                '/news/query/unused',
                param,
                (response) => {
                    // console.debug("queryUnusedContent response:%o", response);

                    commit(types.QUERY_NEWS_CONTENT, { response, param })
                    if (typeof(resolve) === 'function') {
                        resolve(response)
                    }
                },
                (err) => {
                    console.error("queryUnusedContent err:%o", err);
                    if (typeof(reject) === 'function') {
                        reject(err)
                    }
                }
            )
        });

    },

    updateNewsContent({ commit }, param) {
        // console.debug("updateNewsContent> param:%o", param);
        let response = {};
        // response.data = param.id;
        response.code = 0;
        commit(types.UPDATE_NEWS_CONTENT, { response, param })
    },

    transferNewsState({ commit }, param) {
        // console.debug("transferNewsState> param:%o", param);
        return new Promise((resolve, reject) => {
            api.apiCommunication(
                '/api/news/transfer',
                param,
                (resp) => {
                    // console.debug("transferNewsState resp:%o", resp);
                    if (typeof(resolve) === 'function') {
                        resolve(resp)
                    }
                },
                (err) => {
                    /*console.debug("transferNewsState fail:%o", err);*/
                    if (typeof(reject) === 'function') {
                        reject(err)
                    }
                }
            )
        });

    },

    getNewLables({ commit }, param) {
        // console.debug("getNewLables> param:%o", param);
        return new Promise((resolve, reject) => {
            api.apiCommunication(
                '/api/news/label',
                param,
                (resp) => {
                    // console.debug("getNewLables resp:%o", resp);
                    if (typeof(resolve) === 'function') {
                        resolve(resp)
                    }
                },
                (err) => {
                    /*console.debug("getNewLables fail:%o", err);*/
                    if (typeof(reject) === 'function') {
                        reject(err)
                    }
                }
            )
        });

    },

    getUserList({ commit }, param) {
        // console.debug("getUserList> param:%o", param);
        return new Promise((resolve, reject) => {
            api.apiCommunication(
                '/api/user/list',
                param,
                (resp) => {
                    // console.debug("getUserList resp:%o", resp);
                    if (typeof(resolve) === 'function') {
                        resolve(resp)
                    }
                },
                (err) => {
                    /*console.debug("getUserList fail:%o", err);*/
                    if (typeof(reject) === 'function') {
                        reject(err)
                    }
                }
            )
        });

    }

}

const mutations = {
    [types.GET_NEWS_LIST_SUCCESS](state, { response }) {
        // console.debug("GET_NEWS_LIST_SUCCESS> response:%o", response);
        let _data = {}
        if (response && response.code === 0) {
            _data = response.data.news
            state.newstotal = Number(response.data.total)
        }
        state.newsdata = _data
    },
    [types.UPDATE_NEWS_DATA](state, { response, param }) {
        // console.debug("UPDATE_NEWS_DATA> response:%o, param:%o", response, param);
        let _data = {}
        if (response.code === 0) {
            _data = param
            state.newsdata = _data
        }
    },
    [types.ADD_NEWS_DATA_DONE](state, { param }) {
        // console.debug("ADD_NEWS_DATA_DONE> param:%o", param);
        if (param && param.id && param.done) {
              // console.debug('lable/update> before newsdata:%o', state.newsdata);
              state.newsdata.filter(u => {
                if (u.id === param.id) {
                  u.done = param.done;
                  return true;
                }
              });
              // console.debug("label/update> after newsdata:%o", state.newsdata);
        }
    },
    [types.UPDATE_NEWS_CONTENT](state, { response, param }) {
        // console.debug("UPDATE_NEWS_CONTENT> response:%o, param:%o", response, param);
        let _data = {}
        if (response.code === 0) {
            _data = param
            // _data.id = response.data
            // _data.created = getNowTime()
            state.newContent = _data
        }
    },
    [types.QUERY_NEWS_CONTENT](state, { response, param }) {
        // console.debug("QUERY_NEWS_CONTENT> response:%o, param:%o", response, param);
        let _data = {}
        let news = response.data.news
        if (response.code === 0 && news) {
            // console.debug("QUERY_NEWS_CONTENT> newsType:%o", newsType);
            // _data.id = -1;
            _data.category = 2
            for(let i in newsType){
                if (newsType.hasOwnProperty(i) && news.category === newsType[i]) {
                    console.log(i,":",newsType[i]);
                    _data.category = i
                };
            }
            _data.content = news.brief || ''
            _data.cover = news.pic || ''
            _data.hotindex = news.hot+'' || ''
            _data.labels = ''
            _data.sourcefrom = news.source+'' || ''
            _data.sourceurl = news.url || ''
            _data.title = news.title || ''
            _data.origintext = news.content || ''

            // console.debug("QUERY_NEWS_CONTENT> _data:%o, news:%o", _data, news);
            state.newContent = _data
        }
    },
    [types.ADD_NEWS_CONTENT](state, { response, param }) {
        // console.debug("ADD_NEWS_CONTENT> response:%o, param:%o", response, param);
        let _data = {}
        if (response.code === 0) {
            _data = param
            _data.id = response.data.newsId
            // _data.created = getNowTime()
        }
        state.newContent = _data
    },

}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ieditor.js